import { Component, OnInit, Pipe, PipeTransform, ViewChild, ElementRef, Input, Inject, Output, AfterViewInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { Lightbox } from 'ngx-lightbox';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'src/app/services/message/message.service';
import { MatDialog, MatTable } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import {environment} from 'src/environments/environment';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import { EventEmitter } from 'events';
import { TranslateService } from '@ngx-translate/core';
import { DomainConfigService } from 'src/app/services/translate/domain-config.service';

@Component({
  selector: 'app-ged',
  templateUrl: './ged.component.html',
  styleUrls: ['./ged.component.scss']
})
export class GedComponent implements OnInit, AfterViewInit {

  ngAfterViewInit() {
    this.checkScroll();
  }

  darkenColor(bgColor: string) {
    if (!bgColor) return '#444';
    const key = bgColor.toLowerCase().substring(0, 7);
    return this.colorMap[key] || '#444'
  }

  scrollLeft() {
    const container = document.querySelector('.filters-container') as HTMLElement;
    if (container) {
      container.scrollBy({ left: -200, behavior: 'smooth' });
      setTimeout(() => this.checkScroll(), 300);
    }
  }
  
  getSubject(subject){
    if(subject === "Thématique d'échange"){
      return "Thématique";
      } else return subject;
  }

  // Fonction pour scroller à droite
  scrollRight() {
    const container = document.querySelector('.filters-container') as HTMLElement;
    if (container) {
      container.scrollBy({ left: 200, behavior: 'smooth' });
      setTimeout(() => this.checkScroll(), 300);
    }
  }

  // Vérifier si on peut scroller
  checkScroll() {
    const container = document.querySelector('.filters-container') as HTMLElement;
    if (container) {
      this.showLeftArrow = container.scrollLeft > 0;
      this.showRightArrow = container.scrollLeft < (container.scrollWidth - container.clientWidth - 5);
    }
  }

  // Ajouter cette fonction sur l'événement scroll du container
  onScroll() {
    this.checkScroll();
  }
  @ViewChild('paginator', {static: true}) paginator: MatPaginator;
  @ViewChild('targetGED', {static: true}) targetGED: ElementRef;
  currentUser = null;
  showLeftArrow = false;
  showRightArrow = false;
  vibrantColors = [
    "#e7e0ff", 
    "#caf1ee", 
    "#fff0d3", 
    "#fbd8dc", 
    "#d8fdd2", 
    "#f4ded1", 
    "#d1e8ff", 
    "#cbf2ef"
  ];

  colorMap: Record<string, string> = {
    '#e7e0ff': '#5d45de', 
    '#caf1ee': '#008476', 
    '#fff0d3': '#9d6b2b', 
    '#fbd8dc': '#cd0635', 
    '#d8fdd2': '#1c8555', 
    '#f4ded1': '#855436', 
    '#d1e8ff': '#0060d3', 
    '#cbf2ef': '#008379'  
  };
  perPage = 30;
  resultsLength = 0;
  files = null;
  chosenFilter = null;
  chosenFilterInstant = null;
  type = "face";
  projectId = null;
  expanded:boolean = false;
  @Input() modeProjet: any;
  drive = false;
  filesadded: any = [];
  newTag = "";
  showpoup: boolean = false;
  //start filtres
  project = null;
  transmitter = null;
  recipient = null;
  copy = null;
  dateBefore : any;
  dateDeadline = null;
  dateDeadlineAfter = null;
  dateAfter : any;
  tag = null;
  statut = null;
  typedoc = null;
  typebloc = null;
  isGeneral = null;
  isThematic = null;
  keyWord = null;
  smartNumber = null;
  modeDoc = false;
  isSearch = false;
  @Output() EventLaunchSearchDoc = new EventEmitter();
  @Input() tags: any[] = [];
  @Input() transmitters: any[] = [];
  @Input() recipients: any[] = [];
  @Input() copies: any[] = [];
  @Input() types: any[] = [];
  
  @Input() projectsinstant: any[] = [];
  @Input() projects: any[] = [];
  @Input() senders: any[] = [];
  @Input() typesinstant: any[] = [];
  searchtypesIns = [];
  dateBeforeinstant: any;
  dateAfterinstant: any;
  typedocinstant = null;
  transmitterinstant = null;
  projectinstant = null;

   emetteurs = [
    { id: 1, nom: 'Dupont', prenom: 'Jean', avatar: 'assets/img/notifvert.png' },
    { id: 2, nom: 'Martin', prenom: 'Sophie', avatar: 'assets/img/notifvert.png' },
    { id: 3, nom: 'Durand', prenom: 'Paul', avatar: 'assets/img/notifvert.png' }
  ];

  years = [2023, 2022, 2021];

  filters = {
    emetteur: '',
    year: ''
  };
  filterValue: string = '';
  projectValue: string = '';
  tagValue: string = '';
  transmitterValue: string = '';
  recipientValue: string = '';
  copyValue: string = '';
  typeValue: string = '';
  filteredProjects: any[] = [];
  filteredTags: any[] = [];
  filteredTransmitters: any[] = [];
  filteredRecipients: any[] = [];
  filteredCopies: any[] = [];
  filteredTypes: any[] = [];
  
  filteredProjectsInst: any[] = [];
  filteredTransmittersInst: any[] = [];
  filteredTypesInst: any[] = [];
  viewMode: 'grid' | 'compact' | 'list' = 'compact';


  
  projectValueInst: string = '';
  transmitterValueInst: string = '';
  typeValueInst: string = '';
  searchtypesfilter = [
    {id: "pdf", nom: "Pdf", image: "search-pdf"},
    {id: "excel", nom: "Excel", image: "search-excel"},
    {id: "word", nom: "Word", image: "search-word"},
    {id: "presentation", nom: "Présentation", image: "search-presentation"},
    {id: "image", nom: "image", image: "search-image"},
    {id: "video", nom: "Vidéo", image: "search-video"},
    //{id: "http", nom: "Lien", image: "search-lien"}
  ]

  getAvatarlUrl(avatarLink){
    return environment.server_url+avatarLink;
  }

  getContactImage(avatarLink){
    return environment.server_url+"/media/profil/"+avatarLink;
  }

  getProjectImage(avatarLink){
    return environment.server_url+"/media/project_img/"+avatarLink;
  }

  getInitials(libelle: string): string {
    const words = libelle.split(' ');
    const getFirstChar = (word: string): string => {
      return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
    };
    const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point

    return initials;
  }

  applyFilters2() {
    this.launchSearchDoc();
  }

  applyFiltersProj() {
    this.loadTags();
    this.launchSearchDoc();
  }

  loadTags(){
    //this.searchTags = [];
    if(this.projectId){
      this.authService.getTagsDocsByProject(this.projectId, this.isThematic, this.isGeneral).subscribe(res => {
        this.tags = res['hydra:member'];
        this.filteredTags = this.tags;
      }, (error) => {
        //console.log(' getTheProject subscribe error '+error.statusText);
      });
    } else if(this.project){
      this.authService.getTagsDocsByProject(this.project.id, this.isThematic, this.isGeneral).subscribe(res => {
        this.tags = res['hydra:member'];
        this.filteredTags = this.tags;
      }, (error) => {
        //console.log(' getTheProject subscribe error '+error.statusText);
      });
    } else {
      this.tags = [];
      this.filteredTags = [];
    }
  }


  constructor(private authService: AuthService,private _lightbox: Lightbox, private dialog: MatDialog, private route: ActivatedRoute) { 
  }

  ngOnInit() {
    console.log("filter files instant *** "+this.type)
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.projectId = this.route.params['value'].ID;
    //if(this.projectId) this.applyFilters('project');
    //else this.applyFilters('all');
    this.filteredTags = this.tags;
    this.filteredTypesInst = this.typesinstant;
    this.senders.forEach(element => {
      const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
      element.color = this.vibrantColors[randomIndex];
    });
    this.filteredTransmittersInst = this.senders;
    console.log("senders "+this.filteredTransmittersInst.length)
    this.filteredProjectsInst = this.projectsinstant;
    if(this.type == 'instant'){
      this.loadProjectsInstant();
    } //else this.applyFilters('all');
  }

  applyTagFilter() {
    const filter = this.filterValue.toLowerCase();
    this.filteredTags = this.tags.filter(tag =>
      tag.libelle.toLowerCase().includes(filter)
    );
  }

  searchProjectInst() {
    const filter = this.projectValueInst.toLowerCase();
    this.filteredProjectsInst = this.projectsinstant.filter(project =>
      project.libelle.toLowerCase().includes(filter)
    );
  }
  
  searchTransmitterInst() {
    const filter = this.transmitterValueInst.toLowerCase();
    this.filteredTransmittersInst = this.senders.filter(sender =>
      sender.fullName.toLowerCase().includes(filter)
    );
  }
  
  searchTypeInst() {
    const filter = this.typeValueInst.toLowerCase();
    this.filteredTypesInst = this.typesinstant.filter(type =>
      type.nom.toLowerCase().includes(filter)
    );
  }

  searchProject() {
    const filter = this.projectValue.toLowerCase();
    this.filteredProjects = this.projects.filter(project =>
      project.libelle.toLowerCase().includes(filter)
    );
  }
  
  searchTag() {
    const filter = this.tagValue.toLowerCase();
    this.filteredTags = this.tags.filter(tag =>
      tag.libelle.toLowerCase().includes(filter)
    );
  }
  
  searchTransmitter() {
    const filter = this.transmitterValue.toLowerCase();
    this.filteredTransmitters = this.transmitters.filter(transmitter =>
      transmitter.fullName.toLowerCase().includes(filter)
    );
  }
  
  searchRecipient() {
    const filter = this.recipientValue.toLowerCase();
    this.filteredRecipients = this.recipients.filter(recipient =>
      recipient.fullName.toLowerCase().includes(filter)
    );
  }
  
  searchCopy() {
    const filter = this.copyValue.toLowerCase();
    this.filteredCopies = this.copies.filter(copy =>
      copy.fullName.toLowerCase().includes(filter)
    );
  }
  
  searchType() {
    const filter = this.typeValue.toLowerCase();
    this.filteredTypes = this.types.filter(type =>
      type.nom.toLowerCase().includes(filter)
    );
  }

  filterFichier(chosenFilter, ID, scroll){
    //console.log({chosenFilter})
    this.chosenFilter = chosenFilter;
    this.projectId = ID;
    this.resultsLength = 0;
    this.files = null;
    this.paginator.pageIndex = 0;
    if(chosenFilter.smartNumber == "instant"){
      console.log("filter files -> instant ")
      this.fetchFilesInstant(0, scroll);
      this.type = "instant";
    } else if(chosenFilter.smartNumber == "projectinstant"){
      this.projectinstant=null;
      this.fetchFilesInstantProject(0, scroll);
      this.type = "instant";
    } else {
      console.log("filter files -> face ")
      this.type = "face";
      this.fetchFiles(0, scroll);
    }
  }

  closeBloc(){
    this.authService.closeBloc.emit("1");
  }

  reset(){
    this.chosenFilter = null;
    this.projectId = null;
    this.resultsLength = 0;
    this.files = null;
    this.paginator.pageIndex = 0;
    this.expanded = false;
  }

  public resetSearch(){
    this.project =null;
    this.transmitter = null;
    this.recipient = null;
    this.copy=null,
    this.tag = null;
    this.typedoc = null;
    this.dateBefore = null;
    this.dateAfter = null;
    this.launchSearchDoc();
  }

  public resetSearchInstant(){
    this.projectinstant = null;
    this.transmitterinstant = null;
    this.typedocinstant = null;
    this.dateBeforeinstant = null;
    this.dateAfterinstant = null;
    this.launchSearchDocInstant();
    if(!this.projectId) this.loadSendersIns();
    this.loadTypesIns();
  }

  onDateBeforChangeIns(newDate: any): void {
    this.dateBeforeinstant = newDate;
    this.launchSearchDocInstant();
    //this.filterMessageCountInst();
  }

  onDateAfterChangeInst(newDate: any): void {
    this.dateAfterinstant = newDate;
    this.launchSearchDocInstant();
    //this.filterMessageCountInst();
  }

  onDateBeforChange(newDate: any): void {
    this.dateBefore = newDate;
    this.launchSearchDoc();
    //this.filterMessageCountInst();
  }

  onDateAfterChange(newDate: any): void {
    this.dateAfter = newDate;
    console.log("dateAfter "+newDate)
    this.launchSearchDoc();
    //this.filterMessageCountInst();
  }

  loadTypesIns(url?: string){
    var typesinstant = [];
    var idTransmitter = (this.transmitterinstant) ? this.transmitterinstant.id : null;
    var idproject = this.projectId;
    if(!this.projectId) idproject = (this.projectinstant) ? (this.projectinstant.id) : null;
    this.authService.getMessageTypesIns(idproject, idTransmitter).subscribe(res => {
      typesinstant = typesinstant.concat(res['hydra:member']);
      this.typesinstant = this.searchtypesfilter.filter(item => typesinstant.includes(item.id));
      this.filteredTypesInst = this.typesinstant;
    }); 
  }
  
  loadSendersIns(){
    var id = (this.projectinstant) ? (this.projectinstant.id) : null;
    this.authService.getContactsExpInstantDoc(id).subscribe(res => {
      this.senders = res['hydra:member'];
      this.senders.forEach(element => {
        const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
        element.color = this.vibrantColors[randomIndex];
      });
      this.filteredTransmittersInst = this.senders;
      //this.projectSendersInit = this.projectSenders;
      //this.sendersLoadedInstant.emit(this.projectSendersInit);
    }, (error) => {
    });
  }

  

  applyFiltersInstant() {
    this.launchSearchDocInstant();
    this.loadTypesIns();
  }

  applyFiltersInstantProj() {
    if(this.projectinstant) this.loadSendersIns();
    this.launchSearchDocInstant();
    this.loadTypesIns();
  }

  

  launchSearchDocInstant(){
    console.log("filter files launchSearchDocInstant ")
    if(this.typedocinstant=="http") {
      alert("Vous ne pouvez pas sélectionner le type lien pour rechercher un document");
      return;
    }
    this.chosenFilter = { 
      projectinstant: (this.projectinstant) ? this.projectinstant.id : null,
      transmitterinstant: (this.transmitterinstant) ? this.transmitterinstant.id : null,
      dateBeforeinstant: this.dateBeforeinstant,
      dateAfterinstant: this.dateAfterinstant,
      typeinstant: (this.typedocinstant) ? this.typedocinstant.id : null,
      smartNumber: (this.projectinstant) ? "instant" : "projectinstant"
    };
    console.log("filter files filterFichier from launchSearchDocInstant")
    this.filterFichier(this.chosenFilter, this.projectId, true);
    //this.EventLaunchSearchDoc.emit(this.chosenFilterInstant);
  }

  onSelectResponse(event){
    event.addedFiles.map((item)=>{
      this.filesadded.push(item);
      //this.addFile();
    })   
  }

  addFile() {
    var projectid = '/api/projects/' + this.projectId;
    var newTag = (<HTMLInputElement>document.getElementById("newTag")).value;
    if(newTag.trim() == "" || newTag.trim().length == 0){
      alert("Veuillez entrer un tag");
      return;
    }

    if(this.filesadded.length == 0){
      alert("Veuillez sélectionner les fichiers");
      return;
    }
    this.authService.addFile(newTag, projectid, this.filesadded).subscribe(res => {
      this.fetchFiles(0, 0);
      this.filesadded = [];
    },error => {
      alert("oups une erreur s'est produite!");
    });
  }

  onRemoveAnswer(event) {
    this.filesadded.splice(this.files.indexOf(event), 1);
  }

  onRemoveFile(event) {
    this.filesadded.splice(this.files.indexOf(event), 1);
  }

  openpopup(){
    this.showpoup = !this.showpoup;
    (<HTMLInputElement>document.getElementById("newTag")).value = "";
  }

  fetchFiles(page, scroll){
    this.expanded = true;
    this.showpoup = false;
    this.drive = this.chosenFilter.drive;
    if(this.chosenFilter.type == "http") {
      this.files = [];
      return;
    }
    console.log("filter files ss")
    this.authService.getFiles(this.projectId, page, this.perPage, null, this.chosenFilter, false).subscribe(res => {
      this.resultsLength = res['hydra:totalItems']; 
      this.files = res["hydra:member"];
    })
    /*if(this.drive){
      this.authService.getFiles(this.projectId, page, this.perPage, null, this.chosenFilter, true).subscribe(res => {
        this.resultsLength = this.resultsLength + res['hydra:totalItems']; 
        this.files = this.files.concat(res["hydra:member"]);
        this.files.sort((a, b) => {
          return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
        })
      })
    }*/
    if(scroll)
          this.targetGED.nativeElement.scrollIntoView({behavior:"smooth"});
  }

  downloadFile(media: any): void {
    const encodedFileName = encodeURIComponent(media.originalName);
    //return `path/to/your/files/${media.path}?filename=${encodedFileName}`;
    const link = document.createElement('a');
    console.log("name : "+this.getMediaLink(media)+'?filename='+encodedFileName)
    link.href = this.getMediaLink(media)+'?filename='+encodedFileName;
    link.download = 'simplefile.pdf';
    link.click();
  }

  fetchFilesInstantProject(page, scroll){
    this.expanded = true;
    this.showpoup = false;
    this.authService.getFilesInstantProject(this.projectId, page, this.perPage, null, this.chosenFilter, false).subscribe(res => {
      this.resultsLength = res['hydra:totalItems']; 
      this.files = res["hydra:member"];
    })
    if(scroll)
          this.targetGED.nativeElement.scrollIntoView({behavior:"smooth"});
  }

  fetchFilesInstant(page, scroll){
    this.expanded = true;
    this.showpoup = false;
    this.drive = this.chosenFilter.drive;
    this.authService.getFilesInstant(this.projectId, page, this.perPage, null, this.chosenFilter, false).subscribe(res => {
      this.resultsLength = res['hydra:totalItems']; 
      this.files = res["hydra:member"];
    })
    if(this.drive){
      this.authService.getFiles(this.projectId, page, this.perPage, null, this.chosenFilter, true).subscribe(res => {
        this.resultsLength = this.resultsLength + res['hydra:totalItems']; 
        this.files = this.files.concat(res["hydra:member"]);
        this.files.sort((a, b) => {
          return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
        })
      })
    }
    if(scroll)
          this.targetGED.nativeElement.scrollIntoView({behavior:"smooth"});
    /*
    this.authService.getFiles(this.projectId, page, this.perPage, null, this.chosenFilter, true).subscribe(res => {
      //console.log({res})
      this.resultsLength = res['hydra:totalItems']; 
      this.files = res["hydra:member"];
      if(scroll)
        this.targetGED.nativeElement.scrollIntoView({behavior:"smooth"});
      //console.log(res);
    })
    */
  }

  getMediaLink(media){
    //console.log("med : "+media.originalName)
    if(this.type == "instant" || media.message.isTransfered){
      return this.authService.getMediaDataInstant(media.contentUrl);
    } else return this.authService.getMediaData(media.contentUrl);
  }

  open(url){
    

    url = this.getMediaLink(url);
    // alert(url)
    const album = {
      src: url
   };
   let albums = [];
   albums.push(album);
   this._lightbox.open(albums, 0);

   setTimeout(() => {
    document.querySelector( 'img.lb-image' ).removeAttribute("hidden");
    if(document.querySelector( '.lb-loader' )) document.querySelector( '.lb-loader' ).setAttribute("hidden", "true");
    if(document.querySelector( '.lb-nav' )) document.querySelector( '.lb-nav' ).setAttribute("hidden", "true");
   }, 1500);

  }

  handlePage(e: any) {
    console.log("filter files handle page")
    if(this.type == "instant"){
      this.fetchFilesInstant(e.pageIndex, true);
    } else this.fetchFiles(e.pageIndex, true);
  }
  

  getIcon(extension, extensionfile){
    let filelink = "";
    if(extensionfile){
    if(extensionfile.startsWith('xl') || (extensionfile == 'csv' && !extension.includes("text/plain"))){
      filelink = "../../assets/icons/doc-excel.png";
    }else if(extensionfile.startsWith('ppt')){
      filelink = "../../assets/icons/doc-ppt.png";
    }else if((extensionfile.startsWith('do') || extensionfile == 'odt')){
      filelink = "../../assets/icons/doc-word.png";
    }else if(extensionfile.includes("zip")){
      filelink = "../../assets/icons/zip.png";
    }else if(extensionfile.includes("pdf")){
      filelink = "../../assets/icons/doc-pdf.png";
    }else if(extension.includes("text/plain")){
      filelink = "../../assets/img/icone-inconnu.png";
    }}

    return filelink ? filelink : false;
  }

  /*getIcon(extension){
    let filelink = "";
    if(extension.includes("spreadsheetml.sheet") || extension.includes("application/vnd.ms-excel")
    || extension.includes("application/octet-stream") || (extension.includes("text/plain"))){
      filelink = "../../assets/icons/excel.png";
    }else if(extension.includes("presentationml.presentation")){
      filelink = "../../assets/icons/ppt.png";
    }else if(extension.includes("application/msword") || extension.includes("wordprocessingml.document")){
      filelink = "../../assets/icons/word.png";
    }else if(extension == 'application/pdf'){
      filelink = "../../assets/icons/pdf.png";
    }else if(extension.includes("application/zip")){
      filelink = "../../assets/icons/zip.png";
    }else if(extension.includes("video/quicktime")){
      filelink = "../../assets/icons/video.png";
    }

    return filelink ? filelink : false;
  }*/

  openModal(media){

    const dialogRef = this.dialog.open(scrollPjDialog, {
      width: '90%',
      height: '90%',
      data:{files: this.files, currentFile: media}
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log('The dialog was closed result => '+ result);
      if (result) {

      }

    });

  }

  
  launchSearchDoc(){
    if(this.typedoc=="http") {
      alert("Vous ne pouvez pas sélectionner le type lien pour rechercher un document");
      return;
    }
    this.modeDoc = true;

    this.chosenFilter = { 
      transmitter: (this.transmitter) ? this.transmitter.id : null,
      recipient: (this.recipient) ? this.recipient.id : null,
      copy: (this.copy) ? this.copy.id : null,
      projectId: (this.project) ? this.project.id : null,
      //projectId: this.projectId,
      dateBefore: this.dateBefore,
      dateAfter: this.dateAfter,
      dateDeadline: this.dateDeadline,
      dateDeadlineAfter: this.dateDeadlineAfter,
      tag: (this.tag) ? this.tag.id : null,
      statut: this.statut,
      type: (this.typedoc) ? this.typedoc.id : null,
      keyWord: (this.keyWord ? this.keyWord.trim() : null),
      smartNumber: this.smartNumber, 
      drive: this.drive
    };
    console.log("filter files filterFichier from launchSearchDoc")
   this.filterFichier(this.chosenFilter, this.projectId, true);

  }


  loadTypes(url?: string){
    var types = [];
    var idTransmitter = (this.transmitter) ? this.transmitter.id : null;
    var idRecipient = (this.recipient) ? this.recipient.id : null;
    var idCopy = (this.copy) ? this.copy.id : null;
    var idTag = (this.tag) ? this.tag.id : null;
    if(this.projectId){
      this.authService.getMessageTypes(this.projectId, idTransmitter, idRecipient, idCopy, idTag).subscribe(res => {
        types = types.concat(res['hydra:member']);
        this.types = this.searchtypesfilter.filter(item => types.includes(item.id));
        this.filteredTypes = this.types;
      }); 
    } else {
      var idproject = (this.project) ? this.project.id : null;
      this.authService.getMessageTypes(idproject, idTransmitter, idRecipient, idCopy, idTag).subscribe(res => {
        types = types.concat(res['hydra:member']);
        this.types = this.searchtypesfilter.filter(item => types.includes(item.id));
        this.filteredTypes = this.types;
      }); 
    }
  }

  loadTypesProj(url?: string){
    this.types = [];
    var idTransmitter = (this.transmitter) ? this.transmitter.id : null;
    var idRecipient = (this.recipient) ? this.recipient.id : null;
    var idTag = (this.tag) ? this.tag.id : null;
    this.authService.getMessageTypes(this.projectId, idTransmitter, idRecipient, null, idTag).subscribe(res => {
      this.types = this.types.concat(res['hydra:member']);
    }); 
  }

  compare( a, b ) {
    if ( a.givenName.toLowerCase() < b.givenName.toLowerCase() ){
      return -1;
    }
    if ( a.givenName.toLowerCase() > b.givenName.toLowerCase() ){
      return 1;
    }
    return 0;
  }

  loadReceivers(){
    var idTransmitter = (this.transmitter) ? this.transmitter.id : null;
    var idRecipient = (this.recipient) ? this.recipient.id : null;
    var idCopy = (this.copy) ? this.copy.id : null;
    var idTag = (this.tag) ? this.tag.id : null;
    if(this.projectId){
      this.authService.getContactsRecipIDDoc(this.projectId, idTag, idTransmitter).subscribe(res => {
        var tmpArrayUser = res['hydra:member'];
        this.recipients = [];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          if(tmpArrayUser[i].id){
            this.recipients.push(tmpArrayUser[i]);
          }
        }
        this.recipients.sort(this.compare);
        this.recipients.forEach(element => {
          const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
          element.color = this.vibrantColors[randomIndex];
        });
        this.filteredRecipients = this.recipients;
      }, (error) => {
         //console.log(' getTheProject subscribe error '+error.statusText);
      });
    } else {
      var idproject = (this.project) ? this.project.id : null;
      this.authService.getContactsRecipIDDoc(idproject, idTag, idTransmitter).subscribe(res => {
        var tmpArrayUser = res['hydra:member'];
        this.recipients = [];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          if(tmpArrayUser[i].id){
            this.recipients.push(tmpArrayUser[i]);
          }
        }
        this.recipients.sort(this.compare);
        this.recipients.forEach(element => {
          const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
          element.color = this.vibrantColors[randomIndex];
        });
        this.filteredRecipients = this.recipients;
      }, (error) => {
         //console.log(' getTheProject subscribe error '+error.statusText);
      });
    }
  }

  loadCopies(){
    var idTransmitter = (this.transmitter) ? this.transmitter.id : null;
    var idRecipient = (this.recipient) ? this.recipient.id : null;
    var idCopy = (this.copy) ? this.copy.id : null;
    var idTag = (this.tag) ? this.tag.id : null;
    if(this.projectId){
      this.authService.getCopyDoc(this.projectId, idTransmitter, idRecipient, idTag).subscribe(res => {
        var tmpArrayUser = res['hydra:member'];
        this.copies = [];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          if(tmpArrayUser[i].id){
            this.copies.push(tmpArrayUser[i]);
          }
        }
        this.copies.sort(this.compare);
        this.copies.forEach(element => {
          const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
          element.color = this.vibrantColors[randomIndex];
        });
        this.filteredCopies = this.copies;
      }, (error) => {
         //console.log(' getTheProject subscribe error '+error.statusText);
      });
    } else {
      var idproject = (this.project) ? this.project.id : null;
      this.authService.getCopyDoc(idproject, idTransmitter, idRecipient, idTag).subscribe(res => {
        var tmpArrayUser = res['hydra:member'];
        this.copies = [];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          if(tmpArrayUser[i].id){
            this.copies.push(tmpArrayUser[i]);
          }
        }
        this.copies.sort(this.compare);
        this.copies.forEach(element => {
          const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
          element.color = this.vibrantColors[randomIndex];
        });
        this.filteredCopies = this.copies;
      }, (error) => {
         //console.log(' getTheProject subscribe error '+error.statusText);
      });
    }
  }

  loadTransmitters(){
    //this.loadContact();
    var idTag = (this.tag) ? this.tag.id : null;
    if(this.projectId) {
      this.authService.getContactsExpIDDoc(this.projectId, idTag, this.isThematic, this.isGeneral).subscribe(res => {
        this.transmitters = [];
        var tmpArrayUser = res['hydra:member'];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          this.transmitters.push(tmpArrayUser[i]);
        }
        this.transmitters.sort(this.compare);
        this.transmitters.forEach(element => {
          const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
          element.color = this.vibrantColors[randomIndex];
        });
        this.filteredTransmitters = this.transmitters;
      }, (error) => {
          //console.log(' getTheProject subscribe error '+error.statusText);
      });
    } else {
      var idproject = (this.project) ? this.project.id : null;
      this.authService.getContactsExpIDDoc(idproject, idTag, this.isThematic, this.isGeneral).subscribe(res => {
        this.transmitters = [];
        var tmpArrayUser = res['hydra:member'];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          this.transmitters.push(tmpArrayUser[i]);
        }
        this.transmitters.sort(this.compare);
        this.transmitters.forEach(element => {
          const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
          element.color = this.vibrantColors[randomIndex];
        });
        this.filteredTransmitters = this.transmitters;
      }, (error) => {
          //console.log(' getTheProject subscribe error '+error.statusText);
      });
    }
  }

  loadProjects(url?: string){
    url = url ? url : undefined;
    this.projects = [];
    this.authService.getProjectsMessagesDoc().subscribe(res => {
      this.projects = this.projects.concat(res['hydra:member']);
      this.projects.forEach(project => {
        project.randomColor = this.getRandomColor();
      });
      this.filteredProjects = this.projects;
    }); 
  }

  loadProjectsInstant(url?: string){
    url = url ? url : undefined;
    this.projectsinstant = [];
    this.authService.getProjectsMessagesIns().subscribe(res => {
      this.projectsinstant = this.projectsinstant.concat(res['hydra:member']);
      this.projectsinstant.forEach(project => {
        project.randomColor = this.getRandomColor();
      });
      this.filteredProjectsInst = this.projectsinstant;
    }); 
  }

  getRandomColor(): string {
    const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
    return this.vibrantColors[randomIndex];
  }

  resetAllFilters(){
    this.projectValue = "";
    this.tagValue = "";
    this.transmitterValue = "";
    this.recipientValue = "";
    this.copyValue = "";
    this.typeValue = "";
  }

  resetProjectSearchInst(){
    this.projectValueInst = "";
    this.filteredProjectsInst = this.projectsinstant;
  }

  resetTransmitterSearchInst(){
    this.transmitterValueInst = "";
    this.filteredTransmittersInst = this.senders;
  }

  resetTypeSearchInst(){
    this.typeValueInst = "";
    this.filteredTypesInst = this.typesinstant;
  }

  resetProjectSearch(){
    this.projectValue = "";
    this.filteredProjects = this.projects;
  }

  resetTagSearch(){
    this.tagValue = "";
    this.filteredTags = this.tags;
  }

  resetTransmitterSearch(){
    this.recipientValue = "";
    this.filteredTransmitters = this.transmitters;
  }

  resetRecipientSearch(){
    this.recipientValue = "";
    this.filteredRecipients = this.recipients;
  }

  resetCopySearch(){
    this.copyValue = "";
    this.filteredCopies = this.copies;
  }

  resetTypeSearch(){
    this.typeValue = "";
    this.filteredTypes = this.types;
  }

  applyFilters(type: string) {
    const projectId = this.project ? this.project.id : null;
    const subjectId = this.tag ? this.tag.id : null;
    const expediteurId = this.transmitter ? this.transmitter.id : null;
    const destinataireId = this.recipient ? this.recipient.id : null;
    const copyId = this.copy ? this.copy.id : null;
    const typedocId = this.typedoc ? this.typedoc.id : null;
    this.resetAllFilters();

    switch (type) {
      case 'all':
        this.project = null;
        this.tag = null;
        this.transmitter = null;
        this.recipient = null;
        this.copy = null;
        this.typedoc = null;
        this.dateBefore = null;
        this.dateAfter = null;
        console.log("filter files filterFichier from launchSearchDoc all")
        this.launchSearchDoc();

        this.loadProjects();
        this.filteredTags = [];
        this.loadTransmitters();
        this.loadReceivers();
        this.loadCopies();
        this.loadTypes();
        break;

      case 'project':
        this.tag = null;
        this.transmitter = null;
        this.recipient = null;
        this.copy = null;
        this.typedoc = null;
        console.log("filter files filterFichier from launchSearchDoc project")
        this.launchSearchDoc();

        this.loadTags();
        this.loadTransmitters();
        this.loadReceivers();
        this.loadCopies();
        this.loadTypes();
        break;

      // 🟠 CHANGEMENT DE SOUS-GROUPE (SUJET)
      case 'tag':
        this.transmitter = null;
        this.recipient = null;
        this.copy = null;
        this.typedoc = null;
        this.launchSearchDoc();

        this.loadTransmitters();
        this.loadReceivers();
        this.loadCopies();
        this.loadTypes();
        break;

      // 🔵 CHANGEMENT D’EXPÉDITEUR
      case 'transmitter':
        this.recipient = null;
        this.copy = null;
        this.typedoc = null;
        this.launchSearchDoc();

        this.loadReceivers();
        this.loadCopies();
        this.loadTypes();
        break;

      // -------------------------------
      // 🟣 CHANGEMENT DE DESTINATAIRE
      // -------------------------------
      case 'recipient':
        this.copy = null;
        this.typedoc = null;
        this.launchSearchDoc();

        this.loadCopies();
        this.loadTypes();
        break;

      // -------------------------------
      // 🟤 CHANGEMENT DE COPIES
      // -------------------------------
      case 'copy':
        this.typedoc = null;
        this.launchSearchDoc();

        this.loadTypes();
        break;

      // -------------------------------
      // ⚪ CHANGEMENT DE TYPE DE DOCUMENT
      // -------------------------------
      case 'type':
        // On recharge juste la liste finale des documents
        /*this.loadDocuments({
          projectId,
          subjectId,
          expediteurId,
          destinataireId,
          copies: this.selectedCopies,
          typeDoc: this.selectedTypeDocument
        });*/
        this.launchSearchDoc();
        break;

      default:
        console.warn('Type de filtre inconnu:', type);
        break;
    }
  }

}

@Pipe({
  name: 'truncate'
 })
 export class TruncatePipe implements PipeTransform {
 transform(value: string, args: string[]): string {
     const limit = args.length > 0 ? parseInt(args[0], 10) : 20;
     const trail = args.length > 1 ? args[1] : '...';
     return value.length > limit ? value.substring(0, limit) + trail : value;
    }
 }

 @Pipe({
  name: 'dynamicTranslate',
  pure: false  // important : mise à jour dynamique du domaine
})
export class DynamicTranslatePipe implements PipeTransform {

  constructor(
    private translate: TranslateService,
    private domainConfig: DomainConfigService
  ) {}

  transform(key: string): string {
    const params = {
      project: this.domainConfig.getProject(),
      firstproject: this.domainConfig.getFirstproject(),
      allproject: this.domainConfig.getAllproject(),
      projects: this.domainConfig.getProjects(),
      allprojects: this.domainConfig.getAllprojects(),
      subject: this.domainConfig.getSubject(),
      firstsubject: this.domainConfig.getFirstsubject(),
      allsubject: this.domainConfig.getAllsubject(),
      subjects: this.domainConfig.getSubjects(),
      allsubjects: this.domainConfig.getAllsubjects(),
    };

    return this.translate.instant(key, params);
  }
}


@Component({
  templateUrl: './scrollPjDialog.html',
  styleUrls: ['./scrollPjDialog.scss']
})
export class scrollPjDialog {  

  docsUrl = environment.server_url;
  seletedMedia: any;
  currentIndex = 0;
  fileList: any;
  currentMedia: any;

  constructor(
    public dialogRef: MatDialogRef<scrollPjDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private router: Router,
    public dialog: MatDialog,
    protected _sanitizer: DomSanitizer) {
      //console.log("jjjjjjjj");

    //console.log({medialiste: this.data});

    //this.fileList = this.data.files;
    this.currentMedia = this.data.currentFile;
    this.seletedMedia = this.currentMedia;
      /*
    for (var i = 0; i < this.fileList.length; i++) {
      if(this.fileList[i] == this.currentMedia){
        this.currentIndex = i;
      }
    }

    this.seletedMedia = this.fileList[this.currentIndex];*/

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  
  validate(): void {
    this.dialogRef.close();
  }

  onClickPrevious(){
    if ((this.currentIndex-1) >= 0) {
      this.currentIndex -= 1; 
      this.seletedMedia = this.fileList[this.currentIndex];
    }
  }

  onClickNext(){
    if ((this.currentIndex+1) < this.fileList.length) {
      this.currentIndex += 1; 
      this.seletedMedia = this.fileList[this.currentIndex];
    }
  }
 
  getPdfLink(mediaUrl){
      return this._sanitizer.bypassSecurityTrustResourceUrl(this.getMediaLink(mediaUrl));
  }

  getMediaLink(media){
    if(media.message.recipient || media.message.type == "COMMENT"){
      return this.authService.getMediaData(media.contentUrl);
    } else return this.authService.getMediaDataInstant(media.contentUrl);
    /*
    if(!(media.message.recipient) && media.message.type == "MessageInstant"){
      return this.authService.getMediaDataInstant(media.contentUrl);
    } else return this.authService.getMediaData(media.contentUrl);
    */
    //return this.authService.getMediaData(mediaUrl);
  }

  getMediaExtension(media){

    if(media.extensionfile == 'pdf' || media.extensionfile.startsWith('ppt') || media.extensionfile.startsWith('xl') || (media.extensionfile == 'csv') || media.extensionfile.startsWith('do') || media.extensionfile == 'odt' || media.extension == 'application/octet-stream' || media.extensionfile == 'zip'){
      return 1;
    }
    else if (media.extensionfile=='ico' || media.extension.startsWith('image')){
      return 2;
    }
    else if(media.extension.startsWith('audio')){
      return 3;
    }
    else if(media.extension.startsWith('video')){
      return 4;
    }
    else
    {
      return 5;
    }

  }

  getIcon(extension){
    let filelink = "";
    if(extension.includes("spreadsheetml.sheet") || extension.includes("application/vnd.ms-excel")
    || extension.includes("application/octet-stream")){
      filelink = "../../assets/icons/excel.png";
    }else if(extension.includes("presentationml.presentation")){
      filelink = "../../assets/icons/ppt.png";
    }else if(extension.includes("application/msword") || extension.includes("wordprocessingml.document")){
      filelink = "../../assets/icons/word.png";
    }else if(extension == 'application/pdf'){
      filelink = "../../assets/icons/pdf.png";
    }else if(extension.includes("application/zip")){
      filelink = "../../assets/icons/zip.png";
    }else if(extension.includes("video/quicktime")){
      filelink = "../../assets/icons/video.png";
    }

    return filelink ? filelink : false;
  }

}



 